import { render } from "./orderDataTemplateHead.vue?vue&type=template&id=60338c04"
import script from "./orderDataTemplateHead.vue?vue&type=script&lang=js"
export * from "./orderDataTemplateHead.vue?vue&type=script&lang=js"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__